import { render, staticRenderFns } from "./AccountVerificationUpdate.vue?vue&type=template&id=f831e470&"
import script from "./AccountVerificationUpdate.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports